import { Component, OnInit, Inject } from '@angular/core';
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

  constructor() {

  }

  ngOnInit(): void {

  }

  goToWebsite() {
    window.open('https://www.essex.gov.uk/', '_blank');
  }

}
